import { render, staticRenderFns } from "./periodRecord.vue?vue&type=template&id=8b88b7b0"
import script from "./periodRecord.vue?vue&type=script&lang=ts"
export * from "./periodRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports